import { fetchAndProcessData, handleChatParams, handleQuestionParams, hanldeWallParams, handleSimilarParams } from '@/utils/fetch/StreamProcessor';
import { handleMathData, handlePaper, handleAnswer, handleTeacherExplain, handleViewAnswer } from './mathService.js';
import { getBaseURL } from "@/utils/request"
const baseURL = getBaseURL();
export const ApiService = {
    fetchMathData: (params) =>
        fetchAndProcessData(`${baseURL}/MathChat`, handleChatParams(params), handleMathData),

    fetchSubmitAnswer: (answerData) =>
        fetchAndProcessData(`${baseURL}/CheckAnswer`, handleQuestionParams(answerData), handleAnswer),

    fetchTeacherExplain: (params) =>
        fetchAndProcessData(`${baseURL}/TeacherAnswer`, handleQuestionParams(params), handleTeacherExplain),

    fetchViewAnswer: (params) =>
        fetchAndProcessData(`${baseURL}/LookAnswer`, handleQuestionParams(params), handleViewAnswer),

    fetchSimilarQuestions: (params) =>
        fetchAndProcessData(`${baseURL}/SimilarQuestions`, handleSimilarParams(params), handleMathData),

    fetchWallTopic: (data, params) =>
        fetchAndProcessData(`${baseURL}/recommendByKnowledgeWall`, hanldeWallParams(data, params), handleMathData),

    fetchPaperComposition: (params) =>
        fetchAndProcessData(`${baseURL}/TestPaperComposition`, handleChatParams(params), handlePaper),

    fetchKnowledgeReport: (params) =>
        fetchAndProcessData(`${baseURL}/kgNode2report`, handleChatParams(params), handleMathData),
    
    fetchDeepResearch: (aiContent) => {
        const {
          questionIds,
          sessionId,
          continue: isContinue,
          existingContent
        } = aiContent.params;
      
        const controller = aiContent.controller;
        const params = {
          questionIds,
          sessionId,
          continue: isContinue,        // 续写标记
          existingContent,             // 已有内容
          signal: controller ? controller.signal : undefined 
        };
        const data = { aiContent, params };
        return fetchAndProcessData(`${baseURL}/deepResearch`, data, handleMathData);
    }
      
}


